import Cookies from 'js-cookie';
import { AgentIdentity } from './apiParticulierService';

const AUTH_COOKIE_NAME = 'Auth';

const agentStorageKeys = (agentCode: string) => [`${agentCode}`, `${agentCode}-SIM`, `${agentCode}-PV`];

const sharedKeys = ['flowId', 'auditType', 'auditId', 'devisId', 'previsitDocUrl', 'installationDate', 'flowState', 'recoAppointment'];

export const getCurrentAgent = (): AgentIdentity | undefined => {
    const cookie = Cookies.get(AUTH_COOKIE_NAME);
    if (!cookie) return undefined;

    try {
        return JSON.parse(cookie) as AgentIdentity;
    } catch (error) {
        console.warn('Unable to parse Auth cookie', error);
        return undefined;
    }
};

export const clearAgentFootprint = (): void => {
    const agent = getCurrentAgent();
    if (agent?.agentCode) {
        agentStorageKeys(agent.agentCode).forEach((key) => localStorage.removeItem(key));
    }
    sharedKeys.forEach((key) => localStorage.removeItem(key));
};
